module.exports = __webpack_public_path__ + "static/img/result_network.68a619fa.png";